import React from "react";
import PropTypes from "prop-types";

const highlightedId = "grid-superbar-xo";

const GridSuperBar = ({ sizeFilter, availabilityFilter, locationFilter }) => {
  //Superbar class is so that we can target this element from legacy Shortlist grid
  const classes = "superbar flex justify-center md:justify-between p-1 md:p-0";
  return (
    <div id={highlightedId} className={classes} data-test-id="superbar-container">
      {availabilityFilter}
      {locationFilter}
      {sizeFilter}
    </div>
  );
};

GridSuperBar.propTypes = {
  availabilityFilter: PropTypes.object,
  locationFilter: PropTypes.array,
  sizeFilter: PropTypes.object,
};

GridSuperBar.highlightedId = highlightedId;

export default GridSuperBar;
